import { CustomEventProperties } from "core/analytics/analytics.types";
import ReactGA from "react-ga4";

export const trackGaEvent = (name: string, params?: CustomEventProperties) => {
  ReactGA.event(name, params);
};
